import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { referralClient } from "../../core/clients";
import { User } from "@supabase/supabase-js";

type Props = {
  userId: User["id"];
  options: UseQueryOptions<number, Error, number, [string, User["id"]]>;
};

const useGetReferralPointsQuery = ({ userId, options }: Props) => {
  return useQuery(["referralPoints", userId], () => referralClient.getReferralPoints(), options);
};

export default useGetReferralPointsQuery;
